import RejectedCard from "./rejectedCard";
export default RejectedCard;